// src/services/authService.js
import apiClient from './api'; // Axios instance

export default {
  login(credentials) {
    return apiClient.post('/auth/login', credentials);
  },
  register(userData) {
    return apiClient.post('/auth/register', userData);
  },
  getMe() {
    return apiClient.get('/auth/me');
  },
  verifyEmail(token) {
    // Assuming verification is handled by backend redirect now
    // This function might not be needed directly unless frontend calls it
    return apiClient.get(`/auth/verify-email?token=${token}`);
  },
  resendVerification(emailData) {
    // emailData: { email: '...' }
    return apiClient.post('/auth/resend-verification', emailData);
  },
  forgotPassword(data) {
    // data should be { email: 'user@example.com' }
    return apiClient.post('/auth/forgot-password', data);
  },

  resetPassword(token, data) {
    // data should be { password: 'newSecurePassword' }
    // Pass token as a query parameter
    return apiClient.post(`/auth/reset-password?token=${token}`, data);
  }

};
